import ChevronsRightIcon from "@/app/shared-components/icons/ChevronsRightIcon";

interface StickyCTAProps {
  visible: boolean;
  onGetBotbPass: () => void;
  onBuyTickets: () => void;
}

const StickyCTA = ({ visible, onGetBotbPass, onBuyTickets }: StickyCTAProps) => {
  return (
    <div
      className={`fixed !bottom-0 !top-auto inset-x-0 z-[100] bg-white shadow-[0px_0px_20px_0px_rgba(0,0,0,0.2)] px-6 py-2 transition-transform duration-300 ease-in-out ${visible ? "translate-y-0" : "translate-y-full"}`}>
      <div className="flex flex-col items-center gap-2">
        <button
          onClick={onGetBotbPass}
          className="theme-btn theme-btn-primary h-[48px] w-[256px] rounded flex items-center justify-center gap-1.5">
          <span className="flex flex-col items-center">
            <span className="flex items-center gap-1.5">
              <span className="font-jost text-[16px] font-semibold leading-[22px] text-white uppercase">
                GET BOTB PASS
              </span>
              <ChevronsRightIcon variant={4} className="size-4 text-white" />
            </span>
            <span className="font-jost text-[10px] font-medium leading-[12px] text-white/85">
              from £9.99/month - cancel anytime
            </span>
          </span>
        </button>

        <div className="font-jost text-[11px] font-normal leading-[14px] text-[#696971] text-center">
          Or{" "}
          <button onClick={onBuyTickets} className="text-[#28282b] underline decoration-solid">
            buy individual tickets
          </button>{" "}
          from just 5p. Free postal entry available.
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
